import type { RouterConfig } from '@nuxt/schema'
import RoutesHome from './pages/home/routes'
import RoutesRedirect from './pages/redirect/routes'
import { getCurrencyRoutes } from '@core/app/pages/currency/routes'
import { getIMTLiveRoutes } from '@core/app/pages/imt-live/routes'
import imtLiveMiddleware from './pages/imt-live/middleware'
import { getTransferRoutes } from '@core/app/pages/transfer/routes'
import transferMiddleware from './pages/transfer/middleware'
import { getCountryRoutes } from '@core/app/pages/country/routes'
import { getReviewRoutes } from '@core/app/pages/review/routes'
import { getLandingRoutes } from '@core/app/pages/landing/routes'

const options: RouterConfig = {
  routes: (_routes) => [
    ..._routes, // routes from modules
    ...RoutesHome,
    ...RoutesRedirect,
    ...getCurrencyRoutes(async () => import('./pages/currency/currency.vue')),
    ...getIMTLiveRoutes(async () => import('./pages/imt-live/imt-live.vue'), imtLiveMiddleware),
    ...getTransferRoutes(async () => import('./pages/transfer/transfer.vue'), transferMiddleware),
    ...getCountryRoutes(async () => import('./pages/country/country.vue')),
    ...getReviewRoutes(async () => import('./pages/review/review.vue')),
    ...getLandingRoutes(async () => import('./pages/landing/landing.vue')),
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { el: to.hash }
    }
    if (from.path === to.path) {
      return false
    }
    return { left: 0, top: 0 }
  },
}

export default options
